var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","icon":"","color":"color6"},on:{"click":function($event){return _vm.openLink()}}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }